/* ============================================================
   SINGSPACE ADMIN - STATUS PILL WHATSAPP (Sobre)
   ============================================================ */

import { SessionStatus } from '../../types/whatsapp.types';

interface StatusPillProps {
  status: SessionStatus;
}

export function StatusPill({ status }: StatusPillProps) {
  const config: Record<
    SessionStatus,
    {
      label: string;
      dotColor: string;
      textColor: string;
    }
  > = {
    disconnected: {
      label: 'Déconnecté',
      dotColor: 'bg-slate-400',
      textColor: 'text-slate-600',
    },
    scanning: {
      label: 'En attente',
      dotColor: 'bg-amber-500',
      textColor: 'text-amber-700',
    },
    connected: {
      label: 'Connecté',
      dotColor: 'bg-emerald-500',
      textColor: 'text-emerald-700',
    },
    error: {
      label: 'Erreur',
      dotColor: 'bg-rose-500',
      textColor: 'text-rose-700',
    },
  };

  const current = config[status] || config.disconnected;

  return (
    <div className="inline-flex items-center gap-2 px-3 py-1 rounded-lg border border-slate-200 bg-white">
      <div className={`w-2 h-2 rounded-full ${current.dotColor}`} />
      <span className={`text-xs font-medium ${current.textColor}`}>{current.label}</span>
    </div>
  );
}
